import type { OrderFeedbackFormSlice } from "~/lib/prismic";
import type { SliceComponentProps } from "@commercekit/prismic";
import { asText } from "@prismicio/helpers";

const OrderFeedBackForm = ({
  slice,
}: SliceComponentProps<OrderFeedbackFormSlice>) => {
  return (
    <div>
      <label
        htmlFor="customer-feedback"
        className="heading strong sm sans-serif feedback-label mb-2"
      >
        {asText(slice?.primary?.feedback_label_title)}
      </label>

      <textarea
        name="customer-article-feedback"
        id="customer-feedback"
        className="form-control"
        placeholder={asText(slice?.primary?.feedback_input_placeholder)}
      ></textarea>
    </div>
  );
};

export default OrderFeedBackForm;
